import React, { useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import SignatureCanvas from 'react-signature-canvas';
import "../TMVoucherStyle.css";
import { Constants } from '../../../../config/appConstants';

const RenderSignature = React.memo(React.forwardRef((props, ref) => {
    return (
        <div className="w-40">
            <SignatureCanvas
                clearOnResize={false}
                ref={ref}
                canvasProps={{
                    className: 'tmVoucherSigCanvas shadow', style: {
                        pointerEvents: props.hasSignature ? 'none' : 'auto',
                        opacity: props.hasSignature ? 0.5 : 1,
                    },
                }}
            />
        </div>
    );
}));


const RenderClearButton = (props) => {
    return (
        <div className="w-40 text-right mb-2">
            <Button style={{ fontSize: '12px' }} onClick={() => props.clearSignature()} className='sigClearBtn'>Clear</Button>
        </div>
    )
}

const TMVoucherSignature = (props) => {
    useEffect(() => {
        if (props.tmVoucherSignature?.isActive && props.signatureRef.current) {
            const signatureAttachment = `${Constants.PNG_BASE64}${props.tmVoucherSignature.attachmentContent}`;
            props.signatureRef.current.fromDataURL(signatureAttachment);
        }
    }, [props.signatureRef, props.tmVoucherSignature]);

    const hasSignature = props?.hasSignature && props?.status !== Constants.IN_PROGRESS;

    return (
        <div>
            <div className="tmVoucherSignature d-flex flexDirectionColumn align-items">
                <RenderClearButton
                    clearSignature={props.clearSignature}
                />
                <RenderSignature
                    key={"TMVoucherSignature"}
                    ref={props.signatureRef}
                    hasSignature={hasSignature}
                />
            </div>
        </div>
    )
}

export default TMVoucherSignature;